import {
    ITemplateComponent,
    ComponentTypes,
    ITemplateHrPersonComponent,
    ITemplateYandexComponent,
} from "entities/template";
import { cleanFormRecord } from "entities/document";
import { LegalYandexWordFields } from "../const/legal_yandex_word_fields";
import {
    hrAccountFields,
    hrAssignmentsFields,
    hrContactFields,
    hrLoanFields,
    hrLoginFields,
    hrMilitaryFields,
    hrQualificationFields,
    hrSubpoenaFields
} from "./field_list";

function isNonEmptyBeyondFlag(value: unknown): boolean {
    return typeof value === "string" && value.trim() !== "";
}

export function cleanUndefinedNullObject<T extends Record<string, any>>(obj: T): Partial<T> {
    return Object.entries(obj).reduce((acc, [key, value]) => {
        // Проверка на null и undefined
        if (value !== null && value !== undefined) {
            acc[key as keyof T] = value;
        }
        return acc;
    }, {} as Partial<T>);
}

export const cleanupExternalRecord = (state: Record<string, any>, components: ITemplateComponent[]): Record<string, any> => {
    const updatedState = {...state};

    // uuid не добавляем
    // приложенные файлы "Текст из файла Word", "Создать тикет с приложенным файлом",
    // file objects не сохраняются в кэш
    components.filter( i => i.type === ComponentTypes.file || i.type === ComponentTypes.saveAndTicket ||  i.type === ComponentTypes.uuid ).forEach(
        (i) => {
            // @ts-ignore
            updatedState[ i.name ] = undefined
        }
    );

    components.filter( i => i.type === "HrPersons" ).forEach(
        (c ) => {
            let component = c as ITemplateHrPersonComponent;
            const hrFields = [...hrLoginFields,
                ...hrQualificationFields,
                ...hrAccountFields,
                ...hrSubpoenaFields,
                ...hrMilitaryFields,
                ...hrLoanFields,
                ...hrContactFields,
                ...hrAssignmentsFields]
            const tail = component.suffix === undefined || component.suffix === null ? '' : component.suffix;
            hrFields.forEach(
                i => updatedState[ i + tail ] = undefined
            );
            updatedState[ "xxcdoc_hr_login" + tail ] = undefined;
        }
    );

    components.filter((i) => i.type === ComponentTypes.legalYandex).forEach((c) => {
        const component = c as ITemplateYandexComponent;
        const tail = component.suffix === undefined || component.suffix === null ? "" : component.suffix;
        const beyondKey = LegalYandexWordFields.ya_is_beyond + tail;
        if (isNonEmptyBeyondFlag(updatedState[beyondKey])) {
            (Object.values(LegalYandexWordFields) as string[]).forEach((field) => {
                updatedState[field + tail] = undefined;
            });
        }
    });

    updatedState.pdfUserPassword = undefined;

    return cleanFormRecord(updatedState);
}
